<template>
  <div class="app-promo-footer" v-if="!dismissed">
    <div class="app-promo-footer__container">
      <!-- Logo a la izquierda -->
      <img
        :src="c_logo_path"
        alt="HelloBB logo"
        class="app-promo-footer__logo"
      />

      <!-- Texto + CTA a la derecha -->
      <div class="app-promo-footer__content">
        <div class="app-promo-footer__title">{{ c_title }}</div>
        <div class="app-promo-footer__bottom">
          <div class="app-promo-footer__text">
            {{ c_subtitle }}
          </div>
          <a
            @click="cta_default()"
            target="_blank"
            rel="noopener"
            class="app-promo-footer__button"
          >
            {{ c_cta_text }}
          </a>
        </div>
      </div>
    </div>
    <button class="app-promo-footer__close" @click="close()" aria-label="Cerrar">
      ×
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const STORAGE_KEY = "appPromoFooterDismissedAt";

export default {
  name: "AppPromoFooter",
  props : {
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: String,
      required: false,
    },
    ctaText: {
      type: String,
      required: false,
    },
    ctaAction: {
      type: Function,
      required: false,
    },
    reappearAfterHours: {
      type: Number,
      required: false,
      default: 0
    },
    logoPath: {
      type: String,
      required: false,
    },
    notShowForTypes: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      dismissed: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      isApp: "isApp",
    }),
    c_title() {
      return this.title || this.$t("apppromo.title");
    },
    c_subtitle() {
      return this.subtitle || this.$t("apppromo.subtitle");
    },
    c_cta_text() {
      return this.ctaText || this.$t("apppromo.ctaDownloadAppStore");
    },
    c_logo_path() {
      return this.logoPath || "/favicon/apple-icon-57x57.png";
    }
  },
  methods: {
    cta_default() {
      if (this.ctaAction) {
        this.ctaAction();
        return;
      }
      window.mixpanel?.track("Click App Promo Footer", { location: "mobile" });
      window.open("/mobile-app-download?utm_source=guest-list", "_blank");
    },
    close() {
      window.mixpanel?.track("Close App Promo Footer", { location: "mobile" });
      this.dismissed = true;
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    },
    checkShouldShow() {
      let listTypeException = false;
      if (this.user){
        this.user.lists.forEach(list => {
          if (this.notShowForTypes.includes(list.type) ) {
            listTypeException = true;
            return;
          }
        })
      }
      if (listTypeException) {
        this.dismissed = true;
        return;
      }

      const dismissedAt = localStorage.getItem(STORAGE_KEY);
      if (!dismissedAt) {
        this.dismissed = false;
        return;
      }
      else {
        const diffHours = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60);
        if (diffHours >= this.reappearAfterHours) {
          this.dismissed = false;
          localStorage.removeItem(STORAGE_KEY);
        }
        else {
          this.dismissed = true;
        }
      }
    }
  },
  mounted() {
    this.checkShouldShow();
    // if isApp modify element with class app-promo-footer top to 0 and bottom to none
    this.$nextTick(() => {
      if (this.isApp) {
        const element = document.querySelector(".app-promo-footer");
        if (element) {
          element.style.top = "0";
          element.style.bottom = "auto";
          element.style.height = "100px";
          document.body.style.paddingTop = "100px";
        }
      }
    });
  },
};
</script>

<style scoped>
.app-promo-footer {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #1e0028;
  color: white;
  z-index: 900;
  padding: 12px 16px;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
}

.app-promo-footer__container {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
}

.app-promo-footer__logo {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  background: white;
  border-radius: 12px;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.app-promo-footer__content {
  flex: 1;
  min-width: 0; /* clave para evitar que el botón se corte */
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.app-promo-footer__title {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}

.app-promo-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap; /* permite que el botón baje si no cabe */
  gap: 8px;
}

.app-promo-footer__text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #e0e0e0;
}

.app-promo-footer__button {
  background: #ffc944;
  color: #1e0028;
  border-radius: 50px;
  font-weight: bold;
  padding: 8px 14px;
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.app-promo-footer__close {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

@media (max-width: 768px) {
  .app-promo-footer {
    display: block;
  }
}

@media (max-width: 480px) {
  .app-promo-footer__container {
    flex-direction: row;
    align-items: center;
  }

  .app-promo-footer__bottom {
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .app-promo-footer__button {
    width: auto;
    text-align: right;
  }

  .app-promo-footer__text {
    flex: 1;
  }
  .app-promo-footer__title {
    font-size: 14px;
  }
}
</style>
